var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRatingsReviews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3667 3.05994C15.4251 2.94189 15.5154 2.84252 15.6273 2.77304C15.7392 2.70356 15.8683 2.66675 16 2.66675C16.1318 2.66675 16.2609 2.70356 16.3728 2.77304C16.4847 2.84252 16.5749 2.94189 16.6334 3.05994L19.7134 9.29861C19.9163 9.70923 20.2158 10.0645 20.5862 10.3339C20.9566 10.6033 21.3869 10.7788 21.84 10.8453L28.728 11.8533C28.8586 11.8722 28.9812 11.9272 29.082 12.0122C29.1829 12.0972 29.2579 12.2087 29.2987 12.3341C29.3395 12.4595 29.3444 12.5938 29.3128 12.7219C29.2812 12.8499 29.2145 12.9665 29.12 13.0586L24.1387 17.9093C23.8102 18.2294 23.5644 18.6246 23.4225 19.0608C23.2806 19.497 23.2468 19.9611 23.324 20.4133L24.5 27.2666C24.5231 27.3971 24.509 27.5314 24.4594 27.6542C24.4098 27.777 24.3266 27.8834 24.2194 27.9613C24.1123 28.0391 23.9853 28.0853 23.8532 28.0945C23.721 28.1037 23.589 28.0755 23.472 28.0133L17.3147 24.7759C16.909 24.5629 16.4576 24.4516 15.9994 24.4516C15.5411 24.4516 15.0897 24.5629 14.684 24.7759L8.52804 28.0133C8.41115 28.0752 8.27924 28.103 8.14731 28.0936C8.01538 28.0842 7.88873 28.038 7.78177 27.9602C7.6748 27.8824 7.59182 27.7762 7.54225 27.6536C7.49268 27.5309 7.47852 27.3969 7.50137 27.2666L8.67604 20.4146C8.75363 19.9622 8.72002 19.4978 8.57809 19.0613C8.43616 18.6249 8.19018 18.2295 7.86137 17.9093L2.88004 13.0599C2.78483 12.968 2.71736 12.8511 2.68532 12.7227C2.65328 12.5943 2.65796 12.4594 2.69881 12.3335C2.73967 12.2076 2.81506 12.0957 2.91641 12.0106C3.01775 11.9254 3.14098 11.8705 3.27204 11.8519L10.1587 10.8453C10.6124 10.7793 11.0432 10.604 11.4142 10.3346C11.7851 10.0652 12.085 9.70963 12.288 9.29861L15.3667 3.05994Z",
    stroke: "url(#paint0_linear_1_313)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_313",
    x1: 2.66431,
    y1: 15.3815,
    x2: 29.3334,
    y2: 15.3815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF7334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7334"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRatingsReviews);
export default __webpack_public_path__ + "static/media/icon-ratings-reviews.1d8c94cbc53ccf9af53a2ed0e5f8efcf.svg";
export { ForwardRef as ReactComponent };